<template>
    <div>
        <Slide class="mobile-user-menu" :isOpen="is_open" :burgerIcon="false" :crossIcon="false" disableOutsideClick>
            <div id="user-mobile-nav-container">
            <loading :active.sync="loading" 
                :is-full-page="true"></loading>
            <div class="d-block w-100 text-right py-1"><a href="#" @click="close" class="d-flex mobile-close mb-2 border-0 justify-content-end align-items-center pt-0">
                <div style="display:inline;font-weight:normal;color:#4e4e4e;">EXIT</div>
                <i class="fa-2x fal fa-times ml-2 mr-0"></i>
            </a></div>
            <div class="d-block p-0" v-if="username">
                <a class="nav-link pt-2 border-0 text-center d-block" href="/profile">
                    <img data-src="/images/mobile-logo-no-text.webp" style="width:40px;max-height:100px" class="lazy d-inline-block">
                    <div class="text-center">
                        {{ username }}
                    </div>
                </a>
                <div class="nav-link collection-icons py-2 d-flex justify-content-center">
                    <a href="/profile/collected" class="small text-center mr-5"><i class="far fa-box-full fa-2x mr-0"></i><br/>Collected</a>
                    <a href="/profile/favorited" class="small text-center"><i class="far fa-heart fa-heart fa-2x mr-0"></i><br/>Favorited</a>
                </div>
                <a class="nav-link py-1" href="/settings/account">
                    <span>
                        <div class="nav-icon mr-3"><i class="far fa-sliders-h"></i></div>
                    SETTINGS</span>
                </a>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1" href="/settings/subscription">
                    <span><div class="nav-icon mr-3"><i class="far fa-box-open"></i></div>MANAGE SUBSCRIPTION</span>
                </a>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1" href="/settings/subscription-boxes">
                    <span><div class="nav-icon mr-3"><i class="far fa-boxes"></i></div>SUBSCRIPTION BOXES</span>
                </a>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1" href="/settings/orders">
                    <span><div class="nav-icon mr-3"><i class="far fa-shopping-bag"></i></div>ORDERS</span>
                </a>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1 mr-3" href="#" @click.prevent="logout">
                    <span><div class="nav-icon mr-3"><i class="far fa-sign-out-alt"></i></div>LOGOUT</span>
                    
                </a>
            </div>
            <div class="d-block ml-auto mr-auto" style="max-width:400px;padding: 0 5%;" v-else>
                <div class="d-block w-100 text-center"><img data-src="/images/mobile-logo-no-text.webp" style="width:50%;max-width:200px" class="d-inline mr-3 lazy"></div>
                <h2 class="mt-2">Login</h2>
                <div class="small text-danger" v-if="form_errors"><span v-for="error in form_errors">{{ error[0] }}</span></div>
                <div class="form-group">
                    <label class="mb-1">Email</label>
                    <input type="text" placeholder="Moonchild@example.com" class="form-control" name="email" v-model="email" :class="{'is-invalid': errors.has('email') }" v-validate data-vv-rules="required|email" v-if="is_open">
                    <div class="invalid-feedback">
                      Your email is required
                    </div>
                </div>
                <div class="form-group">
                    <label class="mb-1">Password</label>
                    <input type="password" v-model="password" name="password" class="form-control" :class="{'is-invalid': errors.has('password') }" v-validate="'required|min:6'" v-if="is_open">
                    <div class="invalid-feedback">
                        Your password is required
                    </div>
                    <p class="text-right"><a href="/password/reset" style="font-size:12px !important">Forgot Password?</a></p>
                </div>
                <button class="btn btn-primary btn-lg btn-block" @click.prevent="loginRequest">Login</button>
                <p class="text-center"><span class="small">or</span><br/><a style="text-decoration:none;" href="/register">Register</a></p>
            </div>
        </div>
        </Slide>
        <a id="mobile-user-icon" aria-label="Open user profile menu" class="nav-link px-3" href="#" @click="open">
            <i class="mobile-nav-icon far fa-user pointer"></i>
        </a>
    </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
export default {
    components: {
        Slide, Loading
    },
    props: ['username'],
    data() {
        return  {
            is_open: false,
            email: null,
            form_errors: null,
            loading: false,
            password: null,
            token: window.Laravel.csrfToken,
        }
    },
    mounted:function(){
    },
    methods: {
        open(e) {
            e.stopPropagation();
            this.is_open = true;
        },
        close(e) {
            e.stopPropagation();
            this.is_open = false;
        },
        loginRequest() {
            this.$validator.validate().then(result => {
                if (!result) {
                    
                }
                else
                {
                    this.login();
                }
            });
        },
        logout() {
            this.loading = true;
            var _this = this;
            this.$http.post('/logout',{
                _token:_this.token,
            }).then(
                function(success) {
                    this.$toasted.show("Successfully logged out! Refreshing page...", {
                        icon : 'check-circle',
                        iconPack: 'custom-class',
                        className: 'display-5',
                        type: 'success',
                        theme: "toasted-primary", 
                        position: "bottom-center", 
                        duration : 2000,
                        singleton : true,
                    });
                    location.reload(true);
                    _this.loading = false;
                }, function (error) {
                    this.$toasted.show(error.data.message, {
                        type: 'error',
                        theme: "toasted-primary", 
                        position: "bottom-center", 
                        duration : 2000,
                    });
                    _this.loading = false;
                }
            );
        },
        login() {
            this.loading = true;
            var _this = this;
            this.$http.post('/login',{
                _token:_this.token,
                email: _this.email,
                password: _this.password,
            }).then(
                function(success) {
                    this.$toasted.show("Success! Refreshing page...", {
                        icon : 'check-circle',
                        iconPack: 'custom-class',
                        className: 'display-5',
                        type: 'success',
                        theme: "toasted-primary", 
                        position: "bottom-center", 
                        duration : 2000,
                        singleton : true,
                    });
                    location.reload(true);
                    _this.loading = false;
                }, function (error) {
                    _this.form_errors = error.data.errors;
                    _this.loading = false;
                }
            );
        }
    },
    http: {
        root: '/root',
        headers: {
            'X-CSRF-Token': Laravel.csrfToken
        }
    }
    
};
</script>
